export default __webpack_public_path__ + "static/media/arjun-mob.cc20596b.png";